// Option lists extracted from the official Place des Energies "Fiche de renseignements"

export const ELEC_COMPTEUR = ["Linky", "Pas de Linky"];

export const ELEC_OPTIONS = [
  "Base",
  "Heures creuses / Heures pleines",
  "Énergie verte",
  "Monophasé",
  "Triphasé",
];

export const GAZ_TYPE = ["Gaz de ville", "Citerne propane"];

export const LOGEMENT_TYPE = ["Maison", "Appartement", "Résidence secondaire", "SCI"];

export const ANNEE_CONSTRUCTION = ["Avant 2000", "Après 2000"];

export const PRESENCE = ["Permanente", "Soir et week-end", "Quelques semaines / mois par an"];

export const RAPPEL_CRENEAUX = [
  "Dès que possible",
  "Matin (9h–12h)",
  "Midi (12h–14h)",
  "Après-midi (14h–17h)",
];

export const TYPE_DEMANDE = ["Mise en service", "Changement de fournisseur"];

export const OUI_NON = ["Oui", "Non"];

export const DPE_CONNU = ["Oui", "Non"];

export const DPE_CLASSES = ["A", "B", "C", "D", "E", "F", "G"];

export const CHAUFFAGE = [
  "Radiateurs électriques",
  "Gaz",
  "Collectif",
  "Pompe à chaleur",
  "Fioul",
  "Plancher chauffant",
  "Solaire",
  "Chaudière à condensation",
  "Cheminée",
  "Poêle à pellets",
  "Poêle à granulés",
];

export const EAU_CHAUDE = [
  "Électrique ballon",
  "Gaz",
  "Collectif",
  "Ballon thermodynamique",
  "Fioul",
  "Pompe à chaleur",
  "Solaire",
];

export const CUISSON = ["Électrique", "Gaz de ville", "Gaz bouteille"];

export const EQUIPEMENTS = [
  "Congélateur(s)",
  "Réfrigérateur(s)",
  "Climatisation",
  "Sèche-serviettes",
  "Lave-linge",
  "Sèche-linge",
  "Lave-vaisselle",
  "Four(s)",
  "Piscine",
  "Spa",
  "Voiture électrique",
];

export const STATUS_META = {
  nouveau: { label: "Nouveau", bg: "bg-blue-100", text: "text-blue-800", dot: "bg-blue-600" },
  en_attente: { label: "En attente", bg: "bg-orange-100", text: "text-orange-800", dot: "bg-orange-500" },
  rappele: { label: "Rappelé", bg: "bg-amber-100", text: "text-amber-800", dot: "bg-amber-500" },
  en_cours: { label: "En cours", bg: "bg-violet-100", text: "text-violet-800", dot: "bg-violet-600" },
  signe: { label: "Signé", bg: "bg-emerald-100", text: "text-emerald-800", dot: "bg-emerald-600" },
  perdu: { label: "Perdu", bg: "bg-rose-100", text: "text-rose-800", dot: "bg-rose-500" },
};

export const STATUS_ORDER = ["nouveau", "en_attente", "rappele", "en_cours", "signe", "perdu"];

export const STATUS_OPTIONS = STATUS_ORDER.map((k) => ({ value: k, label: STATUS_META[k].label }));

export const DRAFT_META = {
  en_cours: { label: "En cours de saisie", bg: "bg-sky-100", text: "text-sky-800", dot: "bg-sky-500" },
  abandonne: { label: "Non finalisé", bg: "bg-slate-200", text: "text-slate-600", dot: "bg-slate-400" },
};
